<template>
  <Modal>
    <Modal.Title
      >Move {{ ids.length }} {{ pluralize('item', ids.length) }}</Modal.Title
    >
    <Modal.Body>
      <Breadcrumb
        :key="breadcrumbKey"
        :items="breadcrumbItems"
        collapse
        @select="handleBreadcrumbSelect"
      />
      <div class="-mx-6 mt-5 h-[268px] overflow-y-auto">
        <div v-if="loading" class="flex h-full items-center justify-center">
          <Spinner :size="22" />
        </div>

        <template v-else-if="folders.length">
          <button
            v-for="folder in folders"
            :key="folder.id"
            type="button"
            class="flex h-14 w-full items-center gap-2.5 border-b border-gray-800/8 px-6 text-left first:border-t"
            :class="{
              'pointer-events-none opacity-50': shouldDisableFolder(folder),
            }"
            @click="handleFolderClick(folder)"
          >
            <div class="size-6 shrink-0">
              <Thumbnail type="folder" />
            </div>
            <p class="truncate text-gray-800">{{ folder.name }}</p>
          </button>
        </template>

        <div
          v-else
          class="flex h-full items-center justify-center font-secondary text-[14px] text-gray-500"
        >
          Move {{ pluralize('item', ids.length) }} here
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <template #left>
        <div
          class="cursor-pointer text-link text-[14px]"
          :class="disableAction && 'pointer-events-none'"
          @click="handleNewFolderClick"
        >
          Create new folder
        </div>
      </template>
      <Button variant="stroke" :disabled="disableAction" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="disableAction"
        :loading="moveItemsLoading"
        @click="handleConfirm"
      >
        Move
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, Breadcrumb, Thumbnail, useModal } from '@dacr/library'
import Spinner from '@/shared/components/Spinner.vue'
import pluralize from 'pluralize'
import { useMoveItems } from './useMoveItems'

const { close } = useModal()

const props = defineProps<{
  ids: string[]
}>()

const {
  loading,
  moveItemsLoading,
  folders,
  breadcrumbItems,
  breadcrumbKey,
  disableAction,
  shouldDisableFolder,
  handleFolderClick,
  handleBreadcrumbSelect,
  handleNewFolderClick,
  handleConfirm,
} = useMoveItems(props.ids, close)
</script>
